// extracted by mini-css-extract-plugin
export default {"content":"_36ddu","text":"_3-lmL"};